import { BaseInputFilter } from "domain/models/base-input-filter";
import { IFunctionRepository } from "../../domain/contracts/function.contracts";
import { Function } from "../../domain/entities/function";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

export class FunctionRepository implements IFunctionRepository {
  async getAll(filter: BaseInputFilter): Promise<Message<Function[]>> {
    const response = await httpClient.get("/function", { params: filter });
    return response.data;
  }
}

export const functionRepository = new FunctionRepository();
